//Constant/URL.js
export const BASE_URL = window.runtime_config?.API_BASE_URL;
